// stores/plants/src/utils/icons.js
// Direct imports so Webpack only bundles the 79 icons used, not all 2,000+.
import ArrowDownUp from "react-bootstrap-icons/dist/icons/arrow-down-up";
import ArrowLeft from "react-bootstrap-icons/dist/icons/arrow-left";
import ArrowRight from "react-bootstrap-icons/dist/icons/arrow-right";
import ArrowUpRight from "react-bootstrap-icons/dist/icons/arrow-up-right";
import ArrowsAngleExpand from "react-bootstrap-icons/dist/icons/arrows-angle-expand";
import Bag from "react-bootstrap-icons/dist/icons/bag";
import BagCheck from "react-bootstrap-icons/dist/icons/bag-check";
import BagPlusFill from "react-bootstrap-icons/dist/icons/bag-plus-fill";
import BellFill from "react-bootstrap-icons/dist/icons/bell-fill";
import BellSlashFill from "react-bootstrap-icons/dist/icons/bell-slash-fill";
import BoxArrowInRight from "react-bootstrap-icons/dist/icons/box-arrow-in-right";
import BoxArrowRight from "react-bootstrap-icons/dist/icons/box-arrow-right";
import BoxArrowUp from "react-bootstrap-icons/dist/icons/box-arrow-up";
import BoxSeam from "react-bootstrap-icons/dist/icons/box-seam";
import CalendarHeart from "react-bootstrap-icons/dist/icons/calendar-heart";
import CameraFill from "react-bootstrap-icons/dist/icons/camera-fill";
import Cart2 from "react-bootstrap-icons/dist/icons/cart2";
import Cart3 from "react-bootstrap-icons/dist/icons/cart3";
import Check2 from "react-bootstrap-icons/dist/icons/check2";
import CheckCircleFill from "react-bootstrap-icons/dist/icons/check-circle-fill";
import ChevronDown from "react-bootstrap-icons/dist/icons/chevron-down";
import ChevronLeft from "react-bootstrap-icons/dist/icons/chevron-left";
import ChevronRight from "react-bootstrap-icons/dist/icons/chevron-right";
import ChevronUp from "react-bootstrap-icons/dist/icons/chevron-up";
import CloudArrowUpFill from "react-bootstrap-icons/dist/icons/cloud-arrow-up-fill";
import Copy from "react-bootstrap-icons/dist/icons/copy";
import CreditCard from "react-bootstrap-icons/dist/icons/credit-card";
import CreditCard2Front from "react-bootstrap-icons/dist/icons/credit-card-2-front";
import DashLg from "react-bootstrap-icons/dist/icons/dash-lg";
import Envelope from "react-bootstrap-icons/dist/icons/envelope";
import EnvelopeCheck from "react-bootstrap-icons/dist/icons/envelope-check";
import EnvelopeFill from "react-bootstrap-icons/dist/icons/envelope-fill";
import EnvelopeHeart from "react-bootstrap-icons/dist/icons/envelope-heart";
import ExclamationCircle from "react-bootstrap-icons/dist/icons/exclamation-circle";
import Eye from "react-bootstrap-icons/dist/icons/eye";
import EyeSlash from "react-bootstrap-icons/dist/icons/eye-slash";
import Facebook from "react-bootstrap-icons/dist/icons/facebook";
import Fire from "react-bootstrap-icons/dist/icons/fire";
import Gem from "react-bootstrap-icons/dist/icons/gem";
import Gift from "react-bootstrap-icons/dist/icons/gift";
import GiftFill from "react-bootstrap-icons/dist/icons/gift-fill";
import Globe2 from "react-bootstrap-icons/dist/icons/globe2";
import GripVertical from "react-bootstrap-icons/dist/icons/grip-vertical";
import HeartFill from "react-bootstrap-icons/dist/icons/heart-fill";
import HouseDoor from "react-bootstrap-icons/dist/icons/house-door";
import Image from "react-bootstrap-icons/dist/icons/image";
import InfoCircle from "react-bootstrap-icons/dist/icons/info-circle";
import InfoCircleFill from "react-bootstrap-icons/dist/icons/info-circle-fill";
import Instagram from "react-bootstrap-icons/dist/icons/instagram";
import JournalText from "react-bootstrap-icons/dist/icons/journal-text";
import Leaf from "react-bootstrap-icons/dist/icons/leaf";
import LightningChargeFill from "react-bootstrap-icons/dist/icons/lightning-charge-fill";
import Link45deg from "react-bootstrap-icons/dist/icons/link-45deg";
import List from "react-bootstrap-icons/dist/icons/list";
import Magic from "react-bootstrap-icons/dist/icons/magic";
import PersonCircle from "react-bootstrap-icons/dist/icons/person-circle";
import PersonVcard from "react-bootstrap-icons/dist/icons/person-vcard";
import Phone from "react-bootstrap-icons/dist/icons/phone";
import PhoneFill from "react-bootstrap-icons/dist/icons/phone-fill";
import Plus from "react-bootstrap-icons/dist/icons/plus";
import Rulers from "react-bootstrap-icons/dist/icons/rulers";
import Scissors from "react-bootstrap-icons/dist/icons/scissors";
import Search from "react-bootstrap-icons/dist/icons/search";
import ShareFill from "react-bootstrap-icons/dist/icons/share-fill";
import ShieldCheck from "react-bootstrap-icons/dist/icons/shield-check";
import ShieldLockFill from "react-bootstrap-icons/dist/icons/shield-lock-fill";
import Sliders from "react-bootstrap-icons/dist/icons/sliders";
import Stars from "react-bootstrap-icons/dist/icons/stars";
import SunFill from "react-bootstrap-icons/dist/icons/sun-fill";
import Tag from "react-bootstrap-icons/dist/icons/tag";
import Tags from "react-bootstrap-icons/dist/icons/tags";
import Telegram from "react-bootstrap-icons/dist/icons/telegram";
import Telephone from "react-bootstrap-icons/dist/icons/telephone";
import TelephoneFill from "react-bootstrap-icons/dist/icons/telephone-fill";
import ThreeDots from "react-bootstrap-icons/dist/icons/three-dots";
import Whatsapp from "react-bootstrap-icons/dist/icons/whatsapp";
import X from "react-bootstrap-icons/dist/icons/x";
import XCircle from "react-bootstrap-icons/dist/icons/x-circle";
import XCircleFill from "react-bootstrap-icons/dist/icons/x-circle-fill";
import XLg from "react-bootstrap-icons/dist/icons/x-lg";

export {
  ArrowDownUp,
  ArrowLeft,
  ArrowRight,
  ArrowUpRight,
  ArrowsAngleExpand,
  Bag,
  BagCheck,
  BagPlusFill,
  BellFill,
  BellSlashFill,
  BoxArrowInRight,
  BoxArrowRight,
  BoxArrowUp,
  BoxSeam,
  CalendarHeart,
  CameraFill,
  Cart2,
  Cart3,
  Check2,
  CheckCircleFill,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CloudArrowUpFill,
  Copy,
  CreditCard,
  CreditCard2Front,
  DashLg,
  Envelope,
  EnvelopeCheck,
  EnvelopeFill,
  EnvelopeHeart,
  ExclamationCircle,
  Eye,
  EyeSlash,
  Facebook,
  Fire,
  Gem,
  Gift,
  GiftFill,
  Globe2,
  GripVertical,
  HeartFill,
  HouseDoor,
  Image,
  InfoCircle,
  InfoCircleFill,
  Instagram,
  JournalText,
  Leaf,
  LightningChargeFill,
  Link45deg,
  List,
  Magic,
  PersonCircle,
  PersonVcard,
  Phone,
  PhoneFill,
  Plus,
  Rulers,
  Scissors,
  Search,
  ShareFill,
  ShieldCheck,
  ShieldLockFill,
  Sliders,
  Stars,
  SunFill,
  Tag,
  Tags,
  Telegram,
  Telephone,
  TelephoneFill,
  ThreeDots,
  Whatsapp,
  X,
  XCircle,
  XCircleFill,
  XLg,
};

const Icon = {
  ArrowDownUp,
  ArrowLeft,
  ArrowRight,
  ArrowUpRight,
  ArrowsAngleExpand,
  Bag,
  BagCheck,
  BagPlusFill,
  BellFill,
  BellSlashFill,
  BoxArrowInRight,
  BoxArrowRight,
  BoxArrowUp,
  BoxSeam,
  CalendarHeart,
  CameraFill,
  Cart2,
  Cart3,
  Check2,
  CheckCircleFill,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CloudArrowUpFill,
  Copy,
  CreditCard,
  CreditCard2Front,
  DashLg,
  Envelope,
  EnvelopeCheck,
  EnvelopeFill,
  EnvelopeHeart,
  ExclamationCircle,
  Eye,
  EyeSlash,
  Facebook,
  Fire,
  Gem,
  Gift,
  GiftFill,
  Globe2,
  GripVertical,
  HeartFill,
  HouseDoor,
  Image,
  InfoCircle,
  InfoCircleFill,
  Instagram,
  JournalText,
  Leaf,
  LightningChargeFill,
  Link45deg,
  List,
  Magic,
  PersonCircle,
  PersonVcard,
  Phone,
  PhoneFill,
  Plus,
  Rulers,
  Scissors,
  Search,
  ShareFill,
  ShieldCheck,
  ShieldLockFill,
  Sliders,
  Stars,
  SunFill,
  Tag,
  Tags,
  Telegram,
  Telephone,
  TelephoneFill,
  ThreeDots,
  Whatsapp,
  X,
  XCircle,
  XCircleFill,
  XLg,
};

export default Icon;
